import { Notification } from "@livingmap/hippo";
import { useTranslation } from "react-i18next";
import { RouteIntercept } from "../../redux/services/types";
import styles from "./RouteIntercept.module.scss";

export default function RouteInterceptSummary({
  intercept,
  inset = true,
}: {
  intercept?: RouteIntercept;
  inset?: boolean;
}) {
  const { i18n } = useTranslation();
  const notification = intercept?.sheet_notification;
  if (!notification) return null;
  return (
    <div className={inset ? styles.summary : styles.summaryInPanel} dir="auto">
      <Notification
        dataQA="route-intercept-summary"
        type="primary"
        fullWidth
        preserveLineBreaks
        contentPadding="20px 20px 20px 12px"
        title={notification.title[i18n.language] || notification.title["en-GB"]}
        message={
          notification.message[i18n.language] || notification.message["en-GB"]
        }
      />
    </div>
  );
}
